export const ShipmentStatusFilter = {
	TodaysShipments: 0,
	TodaysShipmentsNotDispatched: 1,
	TodaysShipmentsDispatched: 2,
	TodaysShipmentsInTransit: 3,
	TodaysShipmentsDelivered: 4,
	FutureShipments: 5,
	FutureShipmentsNotDispatched: 6,
	FutureShipmentsDispatched: 7,
	PastPickupsNotYetTracking: 8,
	TodaysPickupsInGoodStanding: 9,
	TodaysPickupsOutstanding: 10,
	InTransitInGoodStanding: 11,
	InTransitOutstanding: 12,
	TodaysDeliveriesInGoodStanding: 13,
	TodaysDeliveriesOutstanding: 14,
} as const;

export type ShipmentStatusFilter =
	(typeof ShipmentStatusFilter)[keyof typeof ShipmentStatusFilter];

/**
 * Maps summary card `cardType` strings to their corresponding status filter values.
 * Used by `onClickSummaryCard` to convert card identifiers to API-compatible status integers.
 */
export const cardTypeToStatusFilter: Record<string, ShipmentStatusFilter> = {
	notDispatched: ShipmentStatusFilter.TodaysShipmentsNotDispatched,
	dispatched: ShipmentStatusFilter.TodaysShipmentsDispatched,
	inTransit: ShipmentStatusFilter.TodaysShipmentsInTransit,
	delivered: ShipmentStatusFilter.TodaysShipmentsDelivered,
	futureNotDispatched: ShipmentStatusFilter.FutureShipmentsNotDispatched,
	futureDispatched: ShipmentStatusFilter.FutureShipmentsDispatched,
};
